import { c as _c } from "react/compiler-runtime";
import { useAreTabActionButtonsWrapped, WRAPPED_TAB_ACTION_BUTTONS_SPACING } from "@components/common/tabs/tab-action-buttons-wrapped-context";
import { ToggleGroup } from "@flat-ui";
import { useMediaQueryList } from "@hooks/use-media-query";
import { MARKUPS_VIEW_MODE_OPTIONS } from "@pages/project-details/project-markups/calendar/project-markups-calendar-utils";
import { useMarkupsViewQueryParams } from "@pages/project-details/project-markups/calendar/use-markups-view-query-params";
import { DataViewEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { TABS_CONTENT_PADDING } from "@utils/ui-utils";

/**
 * Spacing of the switch on its own row, the same as next to the wrapped project buttons: as far
 * from the tabs as the wrapped buttons are, and as far from the toolbar as the tab content is
 * from the wrapped buttons. The tab content already starts below the tabs by its own padding.
 */
const OWN_ROW_SX = {
  display: "flex",
  width: "fit-content",
  mt: `calc(${WRAPPED_TAB_ACTION_BUTTONS_SPACING} - ${TABS_CONTENT_PADDING})`,
  mb: TABS_CONTENT_PADDING
};
/**
 * Switch between the table, calendar and board views, among the ones that fit the annotations.
 * In the header it is large with only the icons up to medium screens, to match the height of the
 * project buttons, and otherwise medium with icons and labels.
 */
export function MarkupsViewControls(t0) {
  const $ = _c(17);
  const {
    placement
  } = t0;
  const {
    viewMode,
    setViewMode,
    availableViewModes
  } = useMarkupsViewQueryParams();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    isScreenMdOrSmaller
  } = useMediaQueryList();
  const areProjectButtonsWrapped = useAreTabActionButtonsWrapped();
  const isInHeader = placement === "header";
  const isIconOnly = isInHeader && isScreenMdOrSmaller;
  let t1;
  if ($[0] !== availableViewModes || $[1] !== isIconOnly) {
    let t2;
    if ($[3] !== availableViewModes) {
      t2 = t3 => {
        const {
          value
        } = t3;
        return availableViewModes.includes(value);
      };
      $[3] = availableViewModes;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== isIconOnly) {
      t3 = item => isIconOnly ? {
        ...item,
        label: ""
      } : item;
      $[5] = isIconOnly;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t1 = MARKUPS_VIEW_MODE_OPTIONS.filter(t2).map(t3);
    $[0] = availableViewModes;
    $[1] = isIconOnly;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const items = t1;
  let t2;
  if ($[7] !== setViewMode || $[8] !== trackEvent || $[9] !== viewMode) {
    t2 = function changeViewMode(newViewMode) {
      if (newViewMode === viewMode) {
        return;
      }
      setViewMode(newViewMode);
      trackEvent({
        name: DataViewEvents.changeViewMode,
        props: {
          viewMode: newViewMode,
          subject: "annotations"
        }
      });
    };
    $[7] = setViewMode;
    $[8] = trackEvent;
    $[9] = viewMode;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const changeViewMode = t2;
  if (items.length < 2 || isInHeader !== areProjectButtonsWrapped) {
    return null;
  }
  const t3 = isIconOnly ? "large" : "medium";
  const t4 = isInHeader ? undefined : OWN_ROW_SX;
  let t5;
  if ($[11] !== changeViewMode || $[12] !== items || $[13] !== t3 || $[14] !== t4 || $[15] !== viewMode) {
    t5 = <ToggleGroup items={items} value={viewMode} onChange={changeViewMode} size={t3} sxGroup={t4} />;
    $[11] = changeViewMode;
    $[12] = items;
    $[13] = t3;
    $[14] = t4;
    $[15] = viewMode;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}